export default "__VITE_ASSET__riDnQHE3__"